import { IFormattingSettings, UnitSystemType } from '@fulcrum/lib';

export const UnitSystemsTranslationMap = new Map<UnitSystemType, string>([
  ['metric', 'shared.ui.unitSettings.unitSystemOptions.metric'],
  ['imperial', 'shared.ui.unitSettings.unitSystemOptions.imperial'],
  ['ussurveyfeet', 'shared.ui.unitSettings.unitSystemOptions.USSurveyFeet'],
  ['custom', 'shared.ui.unitSettings.unitSystemOptions.custom'],
]);

export function updateMeasurementsSetting(
  newValues: IFormattingSettings,
  oldValues: IFormattingSettings
): IFormattingSettings {
  const values: IFormattingSettings = {};
  if (
    Object.getOwnPropertyNames(newValues).some((v) =>
      [
        'lengthUnit',
        'lengthDecimals',
        'lengthFormatting',
        'lengthFractions',
      ].includes(v)
    )
  ) {
    values.lengthMeasurementUnit = newValues.lengthUnit ?? oldValues.lengthUnit;
    values.lengthMeasurementDecimals =
      newValues.lengthDecimals ?? oldValues.lengthDecimals;
    values.lengthMeasurementFormatting =
      newValues.lengthFormatting ?? oldValues.lengthFormatting;
    values.lengthMeasurementFractions =
      newValues.lengthFractions ?? oldValues.lengthFractions;
  }
  return values;
}

export function sameUnitForMeasurements(
  settings: IFormattingSettings
): boolean {
  return (
    settings.lengthUnit === settings.lengthMeasurementUnit &&
    settings.lengthFormatting === settings.lengthMeasurementFormatting &&
    settings.lengthFractions === settings.lengthMeasurementFractions &&
    settings.lengthDecimals === settings.lengthMeasurementDecimals
  );
}
